import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/utils/apiClient';
import { useAuth } from '@/contexts/AuthContext';

export interface ReferredUser {
  user_id: string;
  full_name: string | null;
  email: string;
  referral_applied_at: string | null;
  has_made_purchase: boolean;
  total_spent: number;
  total_earnings: number;
}

export interface ReferredUsersListResponse {
  practitioner_id: string;
  referral_code: string;
  total_referred_users: number;
  referred_users: ReferredUser[];
}

/**
 * Hook to fetch list of all users referred by a practitioner
 */
export const useReferredUsers = () => {
  const { user } = useAuth();

  const { data, isLoading, error, refetch } = useQuery<ReferredUsersListResponse>({
    queryKey: ['referredUsers', user?.id],
    queryFn: async () => {
      const response = await apiClient.get('/referrals/practitioner/referred-users');
      return response.data;
    },
    enabled: !!user,
    staleTime: 2 * 60 * 1000, // Cache for 2 minutes
  });

  return {
    referredUsers: data?.referred_users || [],
    totalReferredUsers: data?.total_referred_users || 0,
    referralCode: data?.referral_code,
    isLoading,
    error,
    refetch,
  };
};
